import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { app } from '../../config';
import { useNavigate } from 'react-router-dom';
import { Pagination, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { EditTwoTone } from '@ant-design/icons';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';
import NoRecordFound from '../../components/common/NoRecordFound';

function OrganizationTypes() {
  const { t } = useTranslation(['common']);
  let { Search } = Input;
  let navigate = useNavigate();
  let users;
  let searchedUser;
  let searchedMerchant;
  const [editbtn, setEditBtn] = useState('none');
  const [search, setSearch] = useState('');
  const [current, setCurrent] = useState(1);
  const [fetchOrgTypes, setFetchOrgTypes] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [renderList, setRenderList] = useState();
  const [tableShow, setTableShow] = useState(true);
  // const userResp = useFetchUsers();
  const token=getTokenfromUserObj();
  // console.log(userResp);
  // const userCount = userResp.response ? userResp.response.data.length : 0;
  // console.log(userCount);
  useEffect(() => {
    const merchantsList = async () => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user.userType === 'A') setEditBtn('block');
      const limit = 1000;
      const offset = 0;
      const orgTypeResp = await axios.get(`${app.URL}/orgtype/view`,{headers:{auth:token}});
      orgTypeResp.data ? setFetchOrgTypes(orgTypeResp.data.data) : ' ';
      orgTypeResp.data ? setPagesCount(orgTypeResp.data.data.length) : ' ';
      orgTypeResp.data ? setRenderList(orgTypeResp.data.data.slice(0, 10)) : ' ';
    };
    merchantsList();
  }, []);
  console.log(fetchOrgTypes)
  const onSearch = async (value) => {
    console.log(value);
    try {
      const result = await axios.get(`${app.URL}/orgtype/search/${value}`,{headers:{auth:token}});
      console.log(result);
      searchedMerchant = result.data.data;
      setRenderList(searchedMerchant);
      setPagesCount(searchedMerchant.length);
    } catch (e) {
      console.log('Error');
      console.log(e);
      if (e.message) setErr(e.response.data.message);
      setTableShow(false);
    }
  };
  const onChange = async (page, pageSize) => {
    console.log(page);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    setRenderList(fetchOrgTypes.slice(reqObj.offset, reqObj.offset + limit));
    console.log(renderList);
  };

  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(fetchOrgTypes.slice(0, 10));
      setPagesCount(fetchOrgTypes.length);
      setTableShow(true);
    }
    setSearch(e.target.value);
  };

  const editUser = (e) => {
    console.log(e);
    localStorage.setItem('orgTypeId', JSON.stringify(e.organizationTypeId));
    navigate('/orgtype/edit', { replace: true });
  };
  const addUser = () => {
    navigate('/orgtype/add', { replace: true });
  };
  console.log(renderList);

  return (
    <div className='ml-3 col-lg-12 col-md-12 col-sm-12 '>
      <div className='row mt-4'>
        <div className='col-lg-10 col-md-10 col-sm-10 fs-3 fw-bold'>{t('Organization Types Management')}</div>
        {/* <div className="col-lg-2 col-md-2 col-sm-2">
        <button class="btn btn-primary button" onClick={addUser}>Add</button>  
        </div>   */}
      </div>
      <div className='row text-center'>
        <div className='col-lg-6 mt-4 offset-lg-1'>
          <Search
            placeholder='Search by Organization type'
            className='search'
            onChange={handleSearchChange}
            onSearch={onSearch}
            style={{
              width: 300,
            }}
          />
        </div>
        <div className='col-lg-1 col-md-2 col-sm-2 mt-4 '>
          <button class='btn btn-primary button' onClick={addUser}>
            Add
          </button>
        </div>
      </div>

      <div className='col-lg-8 col-md-12 col-sm-12 '>
        <div class=' styled-table '>
          <table class='table text-black'>
            <thead class='thead-light'>
              <tr>
                <th>{t('Organization Type')}</th>
                <th>{t('Status')}</th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {renderList
                ? renderList.map((output) => (
                    <tr
                      className='row-hover'
                      onClick={() => {
                        editUser(output);
                      }}
                    >
                      <td style={{ width: '360px' }}>{output.organizationType ? output.organizationType : 'null'}</td>
                      <td style={{ width: '260px' }}>{output.isActive === 1 ? 'Active' : 'Inactive'}</td>
                      <td>
                        <EditTwoTone
                          displayName='edit'
                          twoToneColor='blue'
                          style={{ fontSize: '20px' }}
                          onClick={() => {
                            editUser(output);
                          }}
                        />
                        {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                         {t('Edit')}
                       </button> */}
                      </td>
                    </tr>
                  ))
                : ' '}
            </tbody>
          </table>
          {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
                  </div>
      </div>
      <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={10} total={pagesCount} />
    </div>
    //     </div>
    //   </div>
    // </div>
  );
}

export default OrganizationTypes;
